// AddressAutocomplete.jsx
import { useMemo, useRef } from "react";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";

const parsePlace = (place) => {
  const comps = place.address_components || [];
  const get = (type) => comps.find((c) => c.types.includes(type))?.long_name || "";
  const street = [get("street_number"), get("route")].filter(Boolean).join(" ");
  const city =
    get("locality") ||
    get("sublocality_level_1") ||
    get("administrative_area_level_2");
  const state = get("administrative_area_level_1");
  const postalCode = get("postal_code");
  const country = get("country");
  const lat = place.geometry?.location?.lat();
  const lng = place.geometry?.location?.lng();

  return {
    formatted: place.formatted_address || "",
    street,
    city,
    state,
    postalCode,
    country,
    placeId: place.place_id,
    location: lat != null && lng != null ? { lat, lng } : undefined,
  };
};

export default function AddressAutocomplete({ onSelect, countries, value, setValue }) {
  const libraries = useMemo(() => ["places"], []);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyAvW4-Ko3xV6BQx90V3pCXF3N97QUeZlVs',
    libraries,
  });

  // const [value, setValue] = useState("");
  const acRef = useRef(null);

  const handlePlaceChanged = () => {
    const place = acRef.current?.getPlace();
    if (!place || !place.address_components) return;
    const parsed = parsePlace(place);
    onSelect?.(parsed);
    setValue(parsed.formatted || value);
  };

  if (loadError) return <p>Failed to load Google Maps.</p>;
  if (!isLoaded) return <p>Loading…</p>;

  return (
    <Autocomplete
      onLoad={(ac) => (acRef.current = ac)}
      onPlaceChanged={handlePlaceChanged}
      options={{
        // Return only what you need = smaller payloads
        fields: [
          "address_components",
          "formatted_address",
          "geometry.location",
          "place_id",
        ],
        types: ["geocode"], // or ["address"]
        // Optional: restrict results to specific countries (e.g., Nigeria + US)
        ...(countries?.length ? { componentRestrictions: { country: countries } } : {}),
      }}
    >
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Start typing an address…"
        className="w-full rounded-xl border px-3 py-2"
        autoComplete="off"
      />
    </Autocomplete>
  );
}
